var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gitImgCom"},[_c('img',{attrs:{"src":_vm.gif,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }